import { Address, getContract, PublicClient, WalletClient } from 'viem';

import valut from '../abis/Valut';

export const getValut = ({
  address,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  address: Address;
}) => {
  return getContract({
    abi: valut,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
